import { translate } from '../../translate';

export type Filter = {
  name: string;
  bucket: string;
  label: string;
  index: number;
};
export type HotelFiltersTypes = {
  BEST: Filter;
  THREE_STAR_PLUS: Filter;
  EXCELLENT: Filter;
  FOUR_STAR_PLUS: Filter;
  FREE_CANCELLATION: Filter;
  FREE_BREAKFAST: Filter;
};
export const HOTELS_FILTERS: HotelFiltersTypes = {
  BEST: {
    name: 'Best',
    bucket: 'common_best_v1',
    label: translate('label_hotels_pills_best'),
    index: -1,
  },
  FOUR_STAR_PLUS: {
    name: '4star+',
    bucket: 'cr_4star_v1',
    label: translate('label_hotels_pills_4_stars_plus'),
    index: -1,
  },
  THREE_STAR_PLUS: {
    name: '3star+',
    bucket: 'cr_cheap_v1',
    label: translate('label_hotels_pills_3_stars_plus'),
    index: -1,
  },
  EXCELLENT: {
    name: 'Excellent',
    bucket: 'cr_excellent_v1',
    label: translate('label_hotels_pills_excellent_rating'),
    index: -1,
  },
  FREE_BREAKFAST: {
    name: 'BreakfastIncluded',
    bucket: 'cr_free_breakfast_v1',
    label: translate('label_hotels_pills_free_breakfast'),
    index: -1,
  },
  FREE_CANCELLATION: {
    name: 'FreeCancellation',
    bucket: 'cr_free_cancellation_v1',
    label: translate('label_hotels_pills_free_cancellation'),
    index: -1,
  },
};
